/* eslint-disable */

/** unique or primary key constraints on table "argo.attribute_schema_definition_type" */
export enum ArgoAttributeSchemaDefinitionTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  AttributeSchemaDefinitionTypePkey = 'attribute_schema_definition_type_pkey'
}

export enum ArgoAttributeSchemaDefinitionTypeEnum {
  /** Numeric data type */
  Number = 'number',
  /** String or Text data type */
  Text = 'text'
}

/** select columns of table "argo.attribute_schema_definition_type" */
export enum ArgoAttributeSchemaDefinitionTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** update columns of table "argo.attribute_schema_definition_type" */
export enum ArgoAttributeSchemaDefinitionTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

